// Copyright (c) 2023 by Move Closer

import { IRelatedService, ModuleContentResolver, ImageData, NavigationItem } from '../../contexts'

import {
  ProfileNavModuleContent,
  ProfileNavModuleContentInput
} from './ProfileNav.contracts'
import { resolveImage, resolveLink, resolveNavigation } from '../resolvers'
import { logger } from '../../support'
import { ResolvedLink } from '../partials'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (original)
 * @author Filip Rurak <filip.rurak@movecloser.pl (edited)
 */
export const resolveProfileNavModuleContent: ModuleContentResolver<ProfileNavModuleContentInput, ProfileNavModuleContent> =
  async (input: ProfileNavModuleContentInput, relatedService: IRelatedService): Promise<ProfileNavModuleContent> => {
    let background: ImageData | null = null
    let items: NavigationItem[] | null = null
    let cta: ResolvedLink | undefined

    if (input.background && typeof input.background !== 'undefined') {
      background = await resolveImage(input.background, relatedService)
    }

    if (typeof input.items !== 'undefined' && input.items) {
      try {
        items = await resolveNavigation(input.items, relatedService)
      } catch (e) {
        logger(e, 'warn')
      }
    }

    if (input.cta) {
      cta = input.cta.relatedTarget ? await resolveLink(input.cta, relatedService) : input.cta as ResolvedLink
    }

    return {
      ...input,
      background,
      items,
      cta
    }
  }
